import React from "react";
import PrivateHeader from "components/Header/PrivateHeader";
import { withRouter } from "react-router-dom";
import { Spin, Alert } from "antd";
import PublicFooter from "../components/Footer/PublicFooter";
import AccessibilityToolbar from "components/AccessibilityToolbar/AccessibilityToolbar";

class PrivateLayout extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isPageLoaded: false,
            showBorderMargin: false
        };
    }
    componentDidMount() {
    }

    render() {
        let isShowSpinner = this.state.isPageLoaded;

        return (
            <div>
                <PrivateHeader />
                {/* Stage 3.9 (Tasks 5/6): reaches the entire authenticated candidate wizard (all tabs
                    of CandidateRegistration.jsx) through this single mount point. */}
                <AccessibilityToolbar />
                <div
                    className={
                        this.state.showBorderMargin
                            ? "container-fluid mainWrapper fullHeight   align-items-center align-items-stretch pl-0 "
                            : "container-fluid mainWrapper fullHeight align-items-center align-items-stretch "
                    }>
                    <div className="fullHeight">
                        <div>
                            {React.cloneElement(this.props.children, { isPageLoaded: this.state.isAnalysisRunning })}
                            {isShowSpinner == true &&
                                <Spin size="large" tip="Fetching page data is in process"><Alert
                                    message="Loading please wait..."
                                    description="Fetching page data, please wait....."
                                    type="warning"
                                /></Spin>}
                        </div>
                    </div>
                </div>
                {/* Phase C.7.4C (§17 Logged-In Page Footer Consistency): the authenticated candidate
                    area previously rendered PublicFooter with none of C.7.4A/C's modernization
                    (plain solid-red background, full 5-link legal/nav row) — visually breaking the
                    "one coherent candidate journey" this phase closes. `hideLinkBar` (already used by
                    the homepage and Registration) and the same gradient treatment Registration uses
                    are reused here — no new component, no duplicated footer markup, no route/link
                    removed (Privacy Policy/Terms & Conditions remain reachable from wherever the
                    candidate agreed to them during registration; this is the authenticated area,
                    which has no equivalent re-consent requirement). */}
                <PublicFooter className="ent-registration-footer" hideLinkBar />
            </div>
        );
    }
}

export default withRouter(PrivateLayout);
